module.exports = __webpack_public_path__ + "img/add.73f8fef0.svg";